import { useState, useEffect } from 'react';
import usePrevious from 'react-utils/hooks/usePrevious';
import UITable from 'UIComponents/table/UITable';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import FormWorkflowDependenciesTableRow from 'ContentComponents/cmv2/form/formAutomation/connectedWorkflows/FormWorkflowDependenciesTableRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ROWS_PER_PAGE = 5;
const FormWorkflowDependenciesTable = ({
  contentId,
  formGuid,
  formWorkflowDependencies,
  hasWorkflowsAppAccess,
  hasWorkflowsDeleteAccess,
  onEditWorkflowEvent,
  onRemoveWorkflowEvent,
  readOnly,
  seleniumKey
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const prevNumberOfWorkflows = usePrevious(formWorkflowDependencies.length) || 0;
  const numberOfWorkflows = formWorkflowDependencies.length;
  useEffect(() => {
    if (prevNumberOfWorkflows > numberOfWorkflows && currentPage > 0 && currentPage * ROWS_PER_PAGE >= numberOfWorkflows) {
      setCurrentPage(Math.ceil(numberOfWorkflows / ROWS_PER_PAGE) - 1);
    }
  }, [prevNumberOfWorkflows, numberOfWorkflows, currentPage]);
  const firstIndex = currentPage * ROWS_PER_PAGE;
  const pageCount = Math.ceil(formWorkflowDependencies.length / ROWS_PER_PAGE);
  const hasPagination = pageCount > 1;
  const rowsToRender = formWorkflowDependencies.slice(firstIndex, firstIndex + ROWS_PER_PAGE);

  // If paginated, pad with extra rows if needed to keep the table
  // the same height for each page
  let extraRows = [];
  if (hasPagination && rowsToRender.length < ROWS_PER_PAGE) {
    extraRows = [...Array(ROWS_PER_PAGE - rowsToRender.length).keys()].map(i => /*#__PURE__*/_jsx("tr", {
      style: {
        backgroundColor: 'inherit'
      },
      children: /*#__PURE__*/_jsx("td", {
        style: i > 0 ? {
          border: 'none'
        } : {}
      })
    }, i));
  }
  return /*#__PURE__*/_jsx(UITable, {
    "data-selenium": seleniumKey,
    responsiveWrapperClassName: "m-y-2",
    children: /*#__PURE__*/_jsxs("tbody", {
      children: [rowsToRender.map(formWorkflowDependency => {
        return /*#__PURE__*/_jsx(FormWorkflowDependenciesTableRow, {
          contentId: contentId,
          formGuid: formGuid,
          formWorkflowDependency: formWorkflowDependency,
          hasWorkflowsAppAccess: hasWorkflowsAppAccess,
          hasWorkflowsDeleteAccess: hasWorkflowsDeleteAccess,
          onEditWorkflowEvent: onEditWorkflowEvent,
          onRemoveWorkflowEvent: onRemoveWorkflowEvent,
          readOnly: readOnly
        }, formWorkflowDependency.flowId);
      }), extraRows, hasPagination && /*#__PURE__*/_jsx("tr", {
        style: {
          backgroundColor: 'inherit'
        },
        children: /*#__PURE__*/_jsx("td", {
          className: "p-x-0",
          children: /*#__PURE__*/_jsx(UIPaginator, {
            maxVisiblePageButtons: 3,
            onPageChange: ({
              target: {
                value
              }
            }) => setCurrentPage(value - 1),
            page: currentPage + 1,
            pageCount: pageCount
          })
        })
      })]
    })
  });
};
export default FormWorkflowDependenciesTable;